/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item1Inputs */

const ja_playdata_home_benefits_item1 = /** @type {(inputs: Playdata_Home_Benefits_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人気のeスポーツタイトルについて詳しく知りたい`)
};

const en_playdata_home_benefits_item1 = /** @type {(inputs: Playdata_Home_Benefits_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know more about popular esports games`)
};

/**
* | output |
* | --- |
* | "I want to know more about popular esports games" |
*
* @param {Playdata_Home_Benefits_Item1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item1 = /** @type {((inputs?: Playdata_Home_Benefits_Item1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item1(inputs)
	return en_playdata_home_benefits_item1(inputs)
});